import { useEffect, useState } from "react";
import type { JSX } from "react/jsx-runtime";
import Dropdown, { type DropdownFilter } from "../Dropdown/Dropdown";
import type { HeaderCategory } from "../HeaderCategory.d.ts";
import { transformCategoriesToFilter } from "../utils";

type Props = {
  categories: HeaderCategory[];
  onFormSubmit: () => void;
  setCategoryId: (categoryId: number) => void;
  categoryId?: number;
};

function CategorySelection({
  categories,
  onFormSubmit,
  setCategoryId,
  categoryId,
}: Props): JSX.Element {
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      onFormSubmit();
      setShouldSubmit(false);
    }
  }, [shouldSubmit, onFormSubmit]);

  function handleFilterSelect(filter: DropdownFilter): void {
    setCategoryId(filter.value);
    setShouldSubmit(true);
  }

  return (
    <>
      <Dropdown
        filters={transformCategoriesToFilter(categories)}
        onFilterSelect={handleFilterSelect}
        listId="category-dropdown-list"
        label="Kategorie auswählen"
        defaultFilter="Alle Kategorien"
      />
      <input name="categoryId" className="hidden" value={categoryId} />
    </>
  );
}

export default CategorySelection;
